import { EntrataSession } from 'auth/EntrataSession';
import axios from 'axios';
import { store } from 'state/store';

import { getLocaleRequestHeaders } from './localeHeaders';
import { BASE_URL } from './URL';

axios.defaults.timeout = 300000;

const apiClient = axios.create({ baseURL: BASE_URL });

apiClient.interceptors.request.use(
  (config: any) => {
    const { headers } = config;
    const { locale } = store.getState();
    return {
      ...config,
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
        'x-form-viewer-id': EntrataSession.applicant?.sid ? EntrataSession.applicant.sid : '',
        ...getLocaleRequestHeaders(locale),
        ...headers,
      },
    };
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // A missing continuation is normal on the first anonymous invitation visit.
      if (
        error.config?.url === '/viewer/auth/invitations/password/resume' ||
        error.config?.url === '/viewer/auth/invitations/passwordless/resume'
      ) {
        return Promise.reject(error);
      }
      const currentPath = window.location.pathname;
      const isLeadProfileVerifySessionRoute =
        /\/lead-profile\/verify-session\/.+\/.+\/entrata-lead-profile-login/.test(currentPath);

      // Avoid a redirect loop when unauthorized on the verify-session route.
      if (isLeadProfileVerifySessionRoute) {
        return Promise.reject(error);
      }

      EntrataSession.setSessionExpired(true);
      sessionStorage.removeItem('viewer.applicant');
      // Redirect to login
      const { appPath } = EntrataSession;
      if (appPath) {
        const url = new URL(appPath);
        const [, orgId, propertyId] = url.pathname.split('/');
        url.pathname = `/${orgId}/${propertyId}/viewer-login`;
        window.location.href = url.toString();
      }
      return Promise.reject(error);
    }

    // Update the error message but keep the original axios error structure
    const serverErrorMessage =
      error?.response?.data?.message || error.message || 'An unspecified error occurred.';
    // eslint-disable-next-line no-param-reassign
    error.message = serverErrorMessage;

    return Promise.reject(error);
  },
);

const { get, post, patch, put, delete: destroy } = apiClient;
export { destroy, get, patch, post, put };
